/**
 * Block 7.6 (2026-05-27): Commissioner UX warning modal.
 *
 * Показується перед POST goods_sale якщо detected активний договір комісії
 * direction='RECEIVED' з тим самим counterparty. Дає 3 actions: створити
 * commission_sale (redirect), продовжити як goods_sale, скасувати.
 */
import type { CommissionerWarningCheck } from '@/api/commissionerWarning';

export type CommissionerWarningChoice = 'create_commission' | 'continue' | 'cancel';

interface Props {
  check: CommissionerWarningCheck;
  onChoose: (c: CommissionerWarningChoice) => void;
}

export default function CommissionerWarningModal({ check, onChoose }: Props) {
  if (!check.is_commissioner_relationship) return null;
  return (
    <div
      data-testid="commissioner-warning-modal"
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(15, 23, 42, 0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <div
        style={{
          maxWidth: 580, width: '100%',
          background: '#fff', borderRadius: 8, padding: '1.25rem 1.5rem',
          boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
        }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="commissioner-warning-title"
      >
        <h3
          id="commissioner-warning-title"
          style={{ margin: 0, color: '#92400e' }}
        >
          ⚠ Виявлено договір комісії
        </h3>
        <p style={{ marginTop: '0.75rem', lineHeight: 1.5, color: '#1f2937' }}>
          {check.warning_message}
        </p>
        {check.recommended_action && (
          <div
            style={{
              marginTop: '0.5rem',
              padding: '0.5rem 0.75rem',
              background: '#eff6ff',
              borderLeft: '3px solid #2563eb',
              borderRadius: 4,
              color: '#1e3a8a',
              fontSize: '0.85rem',
            }}
          >
            <strong>Рекомендація:</strong> {check.recommended_action}
          </div>
        )}
        <div
          style={{
            marginTop: '1rem',
            display: 'flex', gap: '0.5rem', justifyContent: 'flex-end',
            flexWrap: 'wrap',
          }}
        >
          <button onClick={() => onChoose('cancel')}>Скасувати</button>
          <button onClick={() => onChoose('continue')}>
            Продовжити як реалізацію
          </button>
          <button
            className="primary"
            onClick={() => onChoose('create_commission')}
          >
            Створити комісійний продаж
          </button>
        </div>
      </div>
    </div>
  );
}
